/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type CreateContractRequestMutationVariables = Exact<{
  userId: string;
  buyingCompanyId: string;
  supplyingCompanyId: string;
  fromBusinessProfile: Types.BusinessProfile;
  message: string;
}>;


export type CreateContractRequestMutation = { createContractRequest: { id: string, status: string, channelUrl: string } };


export const CreateContractRequestDocument = /*#__PURE__*/ gql`
    mutation CreateContractRequest($userId: uuid!, $buyingCompanyId: uuid!, $supplyingCompanyId: uuid!, $fromBusinessProfile: BusinessProfile!, $message: String!) {
  createContractRequest(
    userId: $userId
    buyingCompanyId: $buyingCompanyId
    supplyingCompanyId: $supplyingCompanyId
    fromBusinessProfile: $fromBusinessProfile
    message: $message
  ) {
    id
    status
    channelUrl
  }
}
    `;
export type CreateContractRequestMutationFn = Apollo.MutationFunction<CreateContractRequestMutation, CreateContractRequestMutationVariables>;

/**
 * __useCreateContractRequestMutation__
 *
 * To run a mutation, you first call `useCreateContractRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractRequestMutation, { data, loading, error }] = useCreateContractRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *      fromBusinessProfile: // value for 'fromBusinessProfile'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateContractRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractRequestMutation, CreateContractRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractRequestMutation, CreateContractRequestMutationVariables>(CreateContractRequestDocument, options);
      }
export type CreateContractRequestMutationHookResult = ReturnType<typeof useCreateContractRequestMutation>;
export type CreateContractRequestMutationResult = Apollo.MutationResult<CreateContractRequestMutation>;
export type CreateContractRequestMutationOptions = Apollo.BaseMutationOptions<CreateContractRequestMutation, CreateContractRequestMutationVariables>;